<template>
  <div class="HomeHead-container">
    <div class="gb-wrap">
      <!-- <img class="head-img" alt="木夕logo" src="@/assets/logo.png" /> -->
      <!-- <div class="head-thumbs"> -->
        <!-- <swiper v-if="swiperSlides.length" class="my-swiper my-swiper_1" :options="swiperOption_1" ref="mySwiper_1" key="1">
          <swiper-slide v-for="(slide, index) in cp_swiperSlides_1" :key="index"> -->
            <!-- <em>{{index + 1}}</em> -->
            <!-- <img :src="$utils.processImgURL(slide, '!n300')" alt />
          </swiper-slide> -->
          <!-- Optional controls -->
          <!-- <div class="swiper-button-prev hidden" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>-->
        <!-- </swiper> -->
        <!-- <swiper v-if="swiperSlides.length" class="my-swiper my-swiper_2" :options="swiperOption_2" ref="mySwiper_2" key="2">
          <swiper-slide v-for="(slide, index) in cp_swiperSlides_2" :key="index"> -->
            <!-- <em>{{index + 1}}</em> -->
            <!-- <img :src="$utils.processImgURL(slide, '!n300')" alt />
          </swiper-slide> -->
          <!-- Optional controls -->
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next hidden" slot="button-next"></div>-->
        <!-- </swiper> -->
        <!-- <home-carousel /> -->
      <!-- </div> -->
      <div class="head-cont clearfix">
        <div class="head-cont-left">
          <div class="head-cont-title">
            逻辑积木
            <br />一款简单好用的软件开发工具
          </div>
          <p class="head-cont-desc">逻辑积木，是一款简单好用的创造力生产工具，用户可通过该工具初步学习到编程知识，创造属于自己的世界，目前软件还在测试阶段。</p>
        </div>
        <TheDownload v-if="!noDownload" class="head-cont-right" />
      </div>
    </div>
  </div>
</template>

<script>
import TheDownload from './TheDownload'
// import HomeCarousel from './HomeCarousel.vue'

export default {
  name: 'HomeHead',
  components: {
    TheDownload,
    // HomeCarousel
  },
  props: {
    noDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let swiperOption = {
      // loop: true,
      // loopedSlides: 8,
      slidesPerView: 'auto',
      // slidesPerGroup: 6,
      speed: 12000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        waitForTransition: true
      },
      allowTouchMove: false
      // grabCursor: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
    }
    return {
      swiperOption_1: {
        ...swiperOption,
        // slidesPerView: 6,
        // slidesOffsetBefore: 90,
        // slidesOffsetAfter: 90,
        initialSlide: 0
      },
      swiperOption_2: {
        ...swiperOption,
        normalizeSlideIndex: false,
        autoplay: {
          ...swiperOption.autoplay,
          reverseDirection: true
        },
        initialSlide: 0,
        on: {
          init: function() {
            this.slideTo(this.slides.length - 5, 0)
          }
        }
      },
      swiperSlides: [
      ]
    }
  },
  computed: {
    swiper_1() {
      return (this.$refs.mySwiper_1 || {}).swiper
    },
    swiper_2() {
      return (this.$refs.mySwiper_2 || {}).swiper
    },
    cp_swiperSlides_1() {
      let slides = this.swiperSlides
      return slides.slice(0, Math.floor(slides.length / 2))
    },
    cp_swiperSlides_2() {
      let slides = this.swiperSlides
      return slides.slice(Math.floor(slides.length / 2))
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$api.getJsonHomeThumbs().then(res => {
        // console.log("res", res);
        let list = res.home_top_imgs || []
        if (list.length > 0) {
          while (list.length < 14) list = list.concat(list)
        }
        this.swiperSlides = list
      })
    }
  }
}
</script>

<style lang="less" scoped>
.HomeHead-container {
  background: #1a2131;
  overflow: hidden;
}

.gb-wrap {
  // padding-top: 70px;
}

.head-img {
  position: absolute;
  left: 0;
  top: 60px;
  height: 60px;
}

.head-thumbs {
  height: 400px;
  // background: rgba(blue, 0.1);
  overflow: hidden;
}

.my-swiper {
  color: #fff;
  /deep/ .swiper-wrapper {
    transition-timing-function: linear;
  }
  .swiper-slide {
    width: fit-content;
    width: 132px;
    height: 176px;
    margin: 0 10px;
    img {
      height: 100%;
      border-radius: 4px;
    }
    em {
      position: absolute;
    }
  }
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: -1px;
    width: 50px;
    z-index: 9;
  }
  &:before {
    left: -1px;
    background-image: linear-gradient(
      -90deg,
      rgba(#1a2131, 0) 1%,
      rgba(#1a2131, 0.5) 25%,
      rgba(#1a2131, 0.8) 57%,
      #1a2131
    );
  }
  &:after {
    right: -1px;
    background-image: linear-gradient(
      90deg,
      rgba(#1a2131, 0) 1%,
      rgba(#1a2131, 0.5) 25%,
      rgba(#1a2131, 0.8) 57%,
      #1a2131
    );
  }
}

.my-swiper_1 {
  margin: 10px 90px;
}

.my-swiper_2 {
  margin: 10px 60px;
  // padding: 0 120px;
}

.head-cont {
  margin-top: 120px;
  padding-bottom: 95px;
}

.head-cont-title {
  line-height: 66px;
  font-size: 40px;
  color: rgba(#fff, 0.85);
}

.head-cont-desc {
  margin-top: 36px;
  line-height: 38px;
  font-size: 20px;
  color: rgba(#fff, 0.7);
}

.head-cont-left {
  float: left;
  width: 570px;
}

.head-cont-right {
  // float: right;
  position: absolute;
  right: 0;
  top: 100px;
}
</style>
